import { types, Instance } from 'mobx-state-tree';
import { ReuseDayResultDtoModelBase } from './ReuseDayResultDtoModel.base';

/* The TypeScript type of an instance of ReuseDayResultDtoModel */
export interface ReuseDayResultDtoModelType extends Instance<typeof ReuseDayResultDtoModel.Type> {}

/* A graphql query fragment builders for ReuseDayResultDtoModel */
export { selectFromReuseDayResultDto, reuseDayResultDtoModelPrimitives, ReuseDayResultDtoModelSelector } from './ReuseDayResultDtoModel.base';

/**
 * ReuseDayResultDtoModel
 *
 * Override routeUuids: the generated base uses types.array(types.identifier), which MST
 * rejects — identifiers must be direct properties of a model, not array elements.
 */
export const ReuseDayResultDtoModel = ReuseDayResultDtoModelBase
  .props({
    routeUuids: types.union(types.undefined, types.array(types.string)),
  })
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
